"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("circle", {
  cx: "5.5",
  cy: "16.5",
  r: "1.5"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "12.5",
  cy: "16.5",
  r: "1.5"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M16 1c-2.39 0-4.49 1.2-5.75 3.02C9.84 4.01 9.43 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V22c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22v-3.08c3.39-.49 6-3.39 6-6.92 0-3.87-3.13-7-7-7M9 6h.29c-.09.32-.16.66-.21.99H3.34C3.89 6.46 5.31 6 9 6M3 8.99h6.08c.16 1.11.57 2.13 1.18 3.01H3zM15 18c0 .37-.21.62-.34.73l-.29.27H3.63l-.29-.27C3.21 18.62 3 18.37 3 18v-4h9.41c.78.47 1.65.79 2.59.92zm1-5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m.5-9H15v5l3.62 2.16.75-1.23-2.87-1.68z"
}, "2")], 'DepartureBoardOutlined');